<template>
	<div class="delete_person">
		<document-title-bar :pathData="isPathData"></document-title-bar>
		<h1 class="doc_main_h1">获取认识的人员数量及列表</h1>
		<!-- 获取认识的人员数量 -->
		<h2 class="doc_main_h2">获取认识的人员数量</h2>
		<h3 class="doc_main_h3">功能描述</h3>
		<p class="doc_main_p">
			获取识别的人员总量。
		</p>
		<h3 class="doc_main_h3">函数</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">int __stdcall SKFaceGetPersonDataBaseNum();</code></pre>
        <h3 class="doc_main_h3">参数</h3>
        <p class="doc_main_p">无</p>
        <h3 class="doc_main_h3">返回值</h3>
        <p class="doc_main_p">
        	int类型，当前终端所关联人员库Person数量。
		</p>
		<h3 class="doc_main_h3">示例代码</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">int nPersonNum = SKFaceGetPersonDataBaseNum();</code></pre>
		<!-- 获取认识的人员列表 -->
		<h2 class="doc_main_h2">获取认识的人员列表</h2>
		<h3 class="doc_main_h3">功能描述</h3>
		<p class="doc_main_p">
			获取识别人员区间列表。
		</p>
		<h3 class="doc_main_h3">函数</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">const char* __stdcall SKFaceGetPersonList(int nStartIndex, int nEndIndex);</code></pre>
        <h3 class="doc_main_h3">参数</h3>
        <p class="doc_main_p">（1）nStartIndex：认识的人员列表开始索引值（第一个为0）</p>
        <p class="doc_main_p">（2）nEndIndex：认识的人员列表结束索引值</p>
        <h3 class="doc_main_h3">返回值</h3>
        <p class="doc_main_p">
        	const char*类型，所选索引范围内认识的人员列表，json格式，例如：
		</p>
		<pre class="doc_main_pre"><code class="doc_main_code">{
    "PersonSum":27,
    "Persons":[
        {
            "Person_id":"551230",
            "Person_Name":"王某某",
            "Person_HeadUrl":"http://skfrm.cn/Uploads/9257871.jpg",
            "Birth":"1994-09-27",
            "Gender":1,
            "Groups":[
                {
                    "Group_Id":"3910",
                    "Group_Path":"注册人员（根目录）/盛开互动/"
                }
            ]
        },
        {
            "Person_id":"551231",
            "Person_Name":"徐某某",
            "Person_HeadUrl":"http://skfrm.cn/Uploads/8900628.jpg",
            "Birth":"1987-01-22",
            "Gender":2,
            "Groups":[
                {
                    "Group_Id":"3910",
                    "Group_Path":"注册人员（根目录）/盛开互动/"
                }
        ]
        }
    ]
}
</code></pre>
		<h3 class="doc_main_h3">示例代码</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">const char *pszPersonList = SKFaceGetPersonList(0,100);</code></pre>
	</div>
</template>
<script>
	import DocumentTitleBar from '../../../../components/documentTitleBar';
	export default{
		components:{
			'document-title-bar':DocumentTitleBar,
		},
		data(){
			return{
				isPathData:['人脸识别','SKFaceLive-Windows','本地接口','获取认识的人员数量及列表'],
			}
		},
		watch:{

		},
		methods:{

		},
		mounted(){

		}
	}
</script>
<style lang="less" rel="stylesheet/less">
	@import '../../../../less/index.less';
	.delete_person{
	}
</style>	



// WEBPACK FOOTER //
// src/views/documents/skfacelivewindows/localface/getPersonList.vue